module.exports = __webpack_public_path__ + "static/media/Drone Buy.d97f4328.jpg";